import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

// Have connectors
const Track12DRed = ({ state, workState, onLabelClick }) => {
	const trackColor = getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED);
	return (
		<g id="Track12DRed" transform="translate(2101.000000, 381.000000)" className="track">
			<path
				d="M193,2.15735245 L170.974386,10.2496588 M160.248664,14.1903355 L90,40"
				stroke={trackColor}
				strokeWidth={tracksWidth} strokeLinecap="round"/>

			<TrackArrow
				strokeColor={trackColor}
				transform="translate(173.310670, 9.350395) rotate(-22.000000) translate(-173.310670, -9.350395) "
				points="177.31067 17.3503949 169.31067 9.35039485 177.31067 1.35039485"/>

			<Label
				onClick={(event, ref) => onLabelClick(event, ref, 'Track12DRed')}
				coords="119.000000, 4.157352"
				text="12D"
				textCoordsX="7.19335938"
				colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			/>
		</g>
	)
};

Track12DRed.propTypes = trackPropTypes;

export default Track12DRed;
